var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('div',{staticClass:"status-d",style:({background: _vm.statusColorMap[_vm.status]})}),_c('span',[_vm._v(_vm._s(_vm.statusText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }